
import { defineComponent } from "vue";
import LargeHeading from "@/views/shared/common/LargeHeading.vue";
import InputField from "@/views/shared/form-parts/InputField.vue";
import CommonInput from "@/views/shared/form-parts/CommonInput.vue";
import NumberInput from "@/views/shared/form-parts/NumberInput.vue";
import PullDownSelect, {
  SelectOptions,
} from "@/views/shared/form-parts/PullDownSelect.vue";
import { Form, Field } from "vee-validate";
import { object, string } from "yup";
import InCaseCheckBox from "@/views/shared/form-parts/InCaseCheckBox.vue";
import { validationMessages as message } from "@/assets/validation/validation-messages";
import Utility from "@/assets/common/scripts/utility";
import { ContactFormInputData } from "@/views/contact-form/ContactForm.vue";
import ContactService from "@/api/contact.service";
import { useGlobalStore } from "@/stores/global";

export const CONTACT_REASON_OPTIONS: SelectOptions[] = [
  {
    label: "【リチャージ依頼】期間内使い切りプラン",
    value: "1",
  },
  {
    label: "お申込みについて",
    value: "2",
  },
  {
    label: "注文内容の変更について",
    value: "3",
  },
  {
    label: "予約のキャンセルについて",
    value: "4",
  },
  {
    label: "受取・返却について",
    value: "5",
  },
  {
    label: "機器の不具合やトラブルについて",
    value: "6",
  },
  {
    label: "機器の紛失・盗難について",
    value: "7",
  },
  {
    label: "利用期間の延長について",
    value: "8",
  },
  {
    label: "請求関連について",
    value: "9",
  },
  {
    label: "その他のお問い合わせ",
    value: "10",
  },
];

export interface ContactFormData {
  formData: ContactFormInputData;
  privacyPolicyChecked: boolean;
}

const contactFormValidSchema = {
  inquiry_name: string().required(message.required).max(100, message.max),
  inquiry_company_name: string().max(200, message.max),
  inquiry_email: string()
    .required(message.required)
    .email(message.email)
    .max(200, message.max),
  inquiry_tel: string().max(20, message.max),
  inquiry_order_no: string().max(12, message.max),
  inquiry_type: string().required(message.required),
  inquiry_content: string().required(message.required).max(500, message.max),
};

export const CONTACT_FORM_FORM_DATA_DEFAULT: ContactFormInputData = {
  inquiry_name: "",
  inquiry_company_name: "",
  inquiry_email: "",
  inquiry_tel: "",
  inquiry_order_no: "",
  inquiry_type: "",
  inquiry_content: "",
  inquiry_token: "",
};

export default defineComponent({
  name: "ContactFormInput",
  components: {
    InCaseCheckBox,
    InputField,
    CommonInput,
    NumberInput,
    PullDownSelect,
    LargeHeading,
    Form,
    Field,
  },
  created() {
    this.globalState.showLoading();
    ContactService.getContactToken()
      .then(({ data }) => {
        if (!data.data || data.result !== "0000") {
          return;
        }
        this.formData.inquiry_token = data.data.inquiry_token;
      })
      .finally(() => {
        this.globalState.hideLoading();
      });
  },
  computed: {
    globalState() {
      return useGlobalStore();
    },
    contactReasonOptions(): SelectOptions[] {
      return CONTACT_REASON_OPTIONS;
    },
    contentFormValidSchema() {
      return object(contactFormValidSchema);
    },
  },
  data(): ContactFormData {
    return {
      formData: { ...CONTACT_FORM_FORM_DATA_DEFAULT },
      privacyPolicyChecked: false,
    };
  },
  methods: {
    onInvalidSubmit(): void {
      Utility.scrollToInvalidElement();
    },
    onSubmit() {
      this.$emit("forwardToCheck", this.formData);
    },
  },
  emits: ["forwardToCheck"],
});
